/**
 * AWS Cognito 設定
 */

export const cognitoConfig = {
  // User Pool ID
  userPoolId:
    process.env.VUE_APP_COGNITO_USER_POOL_ID || "ap-northeast-1_WMENDabBH",

  // App Client ID
  clientId:
    process.env.VUE_APP_COGNITO_CLIENT_ID || "3ermjtjks1koa9kal3ect1e40f",

  // Cognito Domain
  domain:
    process.env.VUE_APP_COGNITO_DOMAIN ||
    "https://ap-northeast-1wmendabbh.auth.ap-northeast-1.amazoncognito.com",

  // リダイレクトURI（環境に応じて自動設定）
  redirectUri:
    process.env.VUE_APP_COGNITO_REDIRECT_URI ||
    `${window.location.origin}/backyard/callback`,

  // サインアウトURI
  signOutUri:
    process.env.VUE_APP_COGNITO_SIGNOUT_URI ||
    `${window.location.origin}/backyard`,

  // レスポンスタイプ
  responseType: "code",

  // スコープ（Cognito App Clientで許可されているスコープのみ指定）
  // profile スコープを追加することで、グループ情報がトークンに含まれる可能性がある
  scope: "openid email profile",
};

/**
 * Cognito Hosted UI ログインURLを生成
 */
export function getLoginUrl(): string {
  const params = new URLSearchParams({
    client_id: cognitoConfig.clientId,
    response_type: cognitoConfig.responseType,
    scope: cognitoConfig.scope,
    redirect_uri: cognitoConfig.redirectUri,
  });

  return `${cognitoConfig.domain}/oauth2/authorize?${params.toString()}`;
}

/**
 * Cognito Hosted UI ログアウトURLを生成
 */
export function getLogoutUrl(): string {
  const params = new URLSearchParams({
    client_id: cognitoConfig.clientId,
    logout_uri: cognitoConfig.signOutUri,
  });

  return `${cognitoConfig.domain}/logout?${params.toString()}`;
}
